/**
 * @file Resolution de l'etat de controle effectif (peutBouger, peutTirer, AutoMove, AutoFire) : regles du MODE x reglages JOUEUR.
 */
import type { ControlOverride } from '@shared/enums';
import type { ControlRules } from '@config/types';
import type { SettingsData } from '../state/PlayerData';
import type { ResolvedControl } from '../state/RuntimeState';

const apply = (allowed: boolean, rule: ControlOverride, playerPref: boolean): boolean => {
  if (!allowed) return false;
  if (rule === 'forceOn') return true;
  if (rule === 'forceOff') return false;
  return playerPref;
};

/**
 * - canMove / canFire viennent du mode uniquement.
 * - autoMove / autoFire : 'forceOn'/'forceOff' imposes par le mode, 'player' = reglage joueur (ON par defaut).
 * Semantique d'execution (ControlSystem / WeaponSystem) :
 *   - autoMove : le chef va seul vers la cible ; si le doigt est pose (input.active), la direction manuelle est prioritaire.
 *   - autoFire=false && canFire : les chats ne tirent QUE pendant que le doigt est pose (tir maintenu, toujours auto-vise).
 *   - canFire=false : aucun tir, aucun ciblage (hub social).
 */
export const resolveControl = (rules: ControlRules, settings: Pick<SettingsData, 'autoMove' | 'autoFire'>): ResolvedControl => ({
  canMove: rules.canMove,
  canFire: rules.canFire,
  autoMove: apply(rules.canMove, rules.autoMove, settings.autoMove),
  autoFire: apply(rules.canFire, rules.autoFire, settings.autoFire),
});

export const sameControl = (a: ResolvedControl, b: ResolvedControl): boolean =>
  a.canMove === b.canMove && a.canFire === b.canFire && a.autoMove === b.autoMove && a.autoFire === b.autoFire;
